const tabelaItem = {
  nota: 1355,
  conceito: 1356,
  conceitoD: 1362,

  roteiroDeEstudo: 3861,
  ferramentas: 3862,
  produtosAprendizagem: 3863,

  aluno: 1028,
  professor: 1304,
  tecnicoAdm: 1394,

  completo: 4100,
  simplificado: 4099,

  virtual: 3859,
  presencial: 2443,

  diretorioDiario: 21,
  graduacao: 1045,

  tipoComponenteTFGEAD: 3864,
}

export default tabelaItem
